import type { LocaleString} from '@dreamstack/i18n';
import { useLocale } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import tw from 'twin.macro'
import { StockBox } from './StockPriceSectionCustom'

const stockIframeSrc = (locale: LocaleString) => {
  const localeParam = locale === 'de' ? '&locale=de_DE' : ''
  return `https://s.tradingview.com/mediumwidgetembed/?symbols=Accentro%20AG&Accentro%20AG=XETR%3AA4Y%7C3m${localeParam}&trendLineColor=rgba(80%2C%20128%2C%20144%2C%201)&underLineColor=rgba(80%2C%20128%2C%20144%2C%200.1)&fontColor=%2383888D&gridLineColor=rgba(203%2C%20203%2C%20203%2C%201)&width=100%25&height=88%25&colorTheme=dark&utm_source=www.accentro.ag&utm_medium=widget&utm_campaign=symbol-overview`
}
const StocksIframe = tw.iframe`w-full h-px-320`

export const StockPriceSectionIframe: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  const locale = useLocale()
  return (
    <StockBox
      style={{
        background: '#1e222d',
      }}
    >
      <StocksIframe src={stockIframeSrc(locale)} />
    </StockBox>
  )
}
